import { render, staticRenderFns } from "./PasswordVerifyPhone.vue?vue&type=template&id=77bdfb97"
import script from "./PasswordVerifyPhone.vue?vue&type=script&lang=ts"
export * from "./PasswordVerifyPhone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports